import { ETheme, EThemeBackground, EThemeColor } from "../entity/Enum";

export function renderColorByTheme(theme?: string | null): string {
  if (theme === ETheme.Dark) {
    return EThemeColor.ColorNeutralForeground1Dark;
  }
  return EThemeColor.ColorNeutralForeground1Light;
}

export function renderBackgroundColorByTheme(theme?: string | null): string {
  if (theme === ETheme.Dark) {
    return EThemeBackground.Dark;
  }
  return EThemeBackground.Light;
}

export function renderColorPrimary(theme?: string | null): string {
  if (theme === ETheme.Dark) {
    return EThemeColor.ColorNeutralForeground2BrandSelectedDark;
  }
  return EThemeColor.ColorNeutralForeground2BrandSelectedLight;
}
